import './camera.css';
import React, { useEffect, useState } from 'react';

import { CAMERAS } from '../../constants'
import { CameraEnhancer } from 'dynamsoft-camera-enhancer';
import { useStore } from '../../Context';

import ImagePreview from './ImagePreview';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AdjustRoundedIcon from '@mui/icons-material/AdjustRounded';
import CameraswitchIcon from '@mui/icons-material/Cameraswitch';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { BackgroundContainer, ButtonsContainer, CameraContainer } from "./cameraStyle";
import useTheme from '../../hooks/useTheme';
import loanlogs from '../../services/loanlogs';

const dniResolution = { width: 720, height: 1200 };
const selfieResolution = { width: 900, height: 600 };

function CameraComponent() {
    const { savePhoto, setCamera, camera } = useStore();
    
    const theme = useTheme()
    
    const [dataUri, setDataUri] = useState(null);
    const [enhancer, setEnhancer] = useState(null);
    const [cameraType, setCameraType] = useState('front')

    const init = async () => {
        try {
            const cameraInit = await CameraEnhancer.createInstance()
            setEnhancer(cameraInit);
            const dniType = camera.type === CAMERAS.DNI_FRONT || camera.type === CAMERAS.DNI_BACK ? true : false;
            const resolution = dniType ? dniResolution : selfieResolution;
            await cameraInit.setResolution(resolution.width, resolution.height);
            await cameraInit.setUIElement(CameraEnhancer.defaultUIElementURL);
            await cameraInit.setUIElement(document.getElementById("enhancerUIContainer"));
            if (!dniType) {
                await rotateCamera(cameraInit, 'front');
            }
            await cameraInit.open(true);
            if (dniType) {
                let area = {
                    x: 10,
                    y: 8,
                    width: 80,
                    height: 80
                };

                if(theme === 'cuotitas') {
                    cameraInit.setViewDecoratorStrokeStyle("focus", "rgb(47, 79, 131)");
                }
                if(theme === 'cuota-ya') {
                    cameraInit.setViewDecoratorStrokeStyle("focus", "rgb(210, 55, 61)");
                }
                if(theme === 'demo') {
                    cameraInit.setViewDecoratorStrokeStyle("focus", "rgb(184, 25, 139)");
                }

                cameraInit.setViewDecoratorLineWidth("focus", 8);

                cameraInit.setViewDecorator(["focus", "crosshair"], area);

            }
        } catch (e) {
            console.log(e)
        }
    }
    const capture = async () => {
        const isOpen = await enhancer.isOpen()
        if (!isOpen) return

        let canvas = await enhancer.getFrame().toCanvas();

        const base64Canvas = cameraType === "back" ?
            await mirrorMode(canvas.toDataURL("image/jpeg", 0.5)) :
            canvas.toDataURL("image/jpeg", 0.5)
        setDataUri(base64Canvas)
        enhancer.close()
    }

    const mirrorMode = (base64Img) => {
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                canvas.width = img.width;
                canvas.height = img.height;

                // Invertir horizontalmente la imagen utilizando transformaciones 2D
                ctx.translate(canvas.width, 0);
                ctx.scale(-1, 1);
                ctx.drawImage(img, 0, 0);

                // Obtener la imagen espejo en formato Base64
                const base64Espejo = canvas.toDataURL("image/jpeg", 0.5);
                resolve(base64Espejo);
            };

            img.onerror = reject;
            img.src = base64Img;
        });
    };
    const rotateCamera = async (enhancer, type) => {
        let rotation = ''
        if (type === 'front') {
            rotation = 'back'
            document.getElementById("enhancerUIContainer").style.transform = "scale(-1,1)";
        } else {
            rotation = 'front'
            document.getElementById("enhancerUIContainer").style.transform = null;
        }
        setCameraType(rotation)
        const cameras = await enhancer.getAllCameras();
        if (cameras.length) {
            await enhancer.selectCamera(...cameras.filter(camera => !camera.label.includes(rotation)))
        }
    }

    useEffect(() => {
        init()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    const handleRetakePhoto = async () => {
        if (!dataUri) return;
        setDataUri(null);
        init()
    };

    const handleConfirmPhoto = () => {
        if (!dataUri) return;
        loanlogs.success('/camera', { response: { cameraType } }).catch(console.log)
        savePhoto({ [camera.type]: dataUri });
        setCamera({ open: false });
    };


    return (
        <BackgroundContainer>
            <>
                {dataUri ? (
                    <ImagePreview dataUri={dataUri} />
                ) : (
                    <div id="enhancerUIContainer" style={{ width: "100%", height: "100%" }}>
                        <CameraContainer className="dce-video-container" />
                    </div>
                )}
                <ButtonsContainer>
                    {dataUri ? (
                        <>
                            <HighlightOffIcon color="error" sx={{ fontSize: 80, margin: '0 0 5% 20%' }} onClick={handleRetakePhoto} />
                            <CheckCircleOutlineIcon color="success" sx={{ fontSize: 80, margin: '0 20% 5% 0' }} onClick={handleConfirmPhoto} />

                        </>
                    ) : (
                        <>
                            <AdjustRoundedIcon sx={{ color: "var(--color-primary)", fontSize: 80, marginLeft: "32%" }} onClick={capture} />
                            <CameraswitchIcon sx={{ color: "var(--color-primary)", fontSize: 40 }} onClick={() => rotateCamera(enhancer, cameraType)} />
                        </>
                    )}
                </ButtonsContainer>
            </>
        </BackgroundContainer>
    );
}

export default CameraComponent;
